import { Component } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UserService} from "../../services/user.service";
import {firstValueFrom} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
})
export class LoginComponent {

	public username = '';
	public password = '';

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private userService: UserService) {
	}

	public login() {
		this.userService.login(this.username, this.password).then(success => {
			if (success) {
				firstValueFrom(this.route.queryParams).then((params: any) => {
					var returnUrl = params.returnUrl || '/';
					this.router.navigate([returnUrl]);
				});
			}
		});
	}
}
